(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vcdms.printer.factory:Printer
   *
   * @description
   *
   */
  angular
    .module('vcdms.vcprinter')
    .factory('Printer', Printer);
  
  
  Printer.$inject = ['restmod'];
  function Printer(restmod) {
    return restmod.model('/routes/printers').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/printers/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          }
        } // Model
      }// extend
    });
  }
  
// klammerfriedhof
}());
